import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import jsPDF from "jspdf";
import "jspdf-autotable";
import React, { useState } from "react";
import { FaPencilAlt, FaTrashAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import PaymentStatusChanger from "../status-chenger/PaymentStatusChanger";
import {ability} from "../../../config/acl/ability";

const RequestDataTable = ({ data,  setData, rowsPerPage, currentPage  }) => {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const canReviewOrder = ability.can('order', 'review');

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = [...data].sort((a, b) => {
    if (!orderBy) return 0;
    if (a[orderBy] < b[orderBy]) return order === "asc" ? -1 : 1;
    if (a[orderBy] > b[orderBy]) return order === "asc" ? 1 : -1;
    return 0;
  });

  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("Faqs Table", 14, 10);
    doc.autoTable({
      startY: 20,
      head: [["ID", "Title", "Description"]],
      body: data.map((item) => [item.id, item.title, item.description]),
    });
    doc.save("faqs_table.pdf");
  };

  return (
    <>
      {/*<button*/}
      {/*  onClick={exportPDF}*/}
      {/*  className="bg-primary text-white p-2 rounded mb-3"*/}
      {/*>*/}
      {/*  Export to PDF*/}
      {/*</button>*/}
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow className="bg-primary">
              {["id", "Domain","Price","Payment Methode" ,"Payment Status" , "User"].map((column) => (
                <TableCell
                  key={column}
                  align="center"
                  className="!text-darkTextColor whitespace-nowrap"
                >
                  <TableSortLabel
                    active={orderBy === column}
                    direction={orderBy === column ? order : "asc"}
                    onClick={() => handleSort(column)}
                  >
                    {column}
                  </TableSortLabel>
                </TableCell>
              ))}
              {/*<TableCell*/}
              {/*  align="center"*/}
              {/*  className="!text-darkTextColor whitespace-nowrap"*/}
              {/*>*/}
              {/*  Actions*/}
              {/*</TableCell>*/}
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData.map((item) => (
              <TableRow
                key={item.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row" align="center">
                  {item?.id}
                </TableCell>
                <TableCell align="center">{item?.domains?.domain}</TableCell>
                <TableCell align="center">{item?.price} $</TableCell>
                <TableCell align="center">{item?.payment_method}</TableCell>
                <TableCell align="center">
                  {(item?.payment_method === "manually" && canReviewOrder) &&
                  item?.status_payment === "pending" ? (
                      <TableCell align="center">
                        <PaymentStatusChanger
                            data={item}
                            setData={setData}
                            rowsPerPage={rowsPerPage}
                            currentPage={currentPage}
                        />
                      </TableCell>
                  ) : (
                      <TableCell align="center">
                    <span
                        className={`badge w-24 text-darkTextColor ${
                            item?.status_payment === "paid"
                                ? "bg-[#28a745]"
                                : item?.status_payment === "pending"
                                ? "bg-[#f7cb73]"
                                : "bg-[#ff6877]"
                        }`}
                    >
                      {item?.status_payment}
                    </span>
                      </TableCell>
                  )}
                </TableCell>
                <TableCell align="center">{item?.user?.name}</TableCell>
                {/*<TableCell align="center">*/}
                {/*  <div className="flex gap-x-10 text-lg items-center justify-center">*/}
                {/*    <Link*/}
                {/*      to={`/EditSmmDomains/${item?.id}`}*/}
                {/*      color="inherit"*/}
                {/*      underline="none"*/}
                {/*    >*/}
                {/*      <FaPencilAlt className="text-[#6c757d]" />*/}
                {/*    </Link>*/}
                {/*    <FaTrashAlt*/}
                {/*      onClick={() => {*/}
                {/*        setSelectedId(item?.id);*/}
                {/*        handleShow();*/}
                {/*      }}*/}
                {/*      className="text-[#d9534f] cursor-pointer"*/}
                {/*    />*/}
                {/*  </div>*/}
                {/*</TableCell>*/}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default RequestDataTable;
